/**
 * Pure builder for the versioned _pack_payload cart-line property
 * (see backoffice/functions/src/schemas/packPayload.ts for the contract
 * this must match). Dual-environment: usable as a classic browser
 * <script> (attaches to window) and via Node require/import for
 * standalone verification (scripts/verify-pack-payload.mjs). Must not
 * reference document, window, or this — no DOM dependency.
 */
function buildPackPayload(selectedMeals) {
  const meals = [];

  for (const productId of Object.keys(selectedMeals)) {
    const meal = selectedMeals[productId];
    const quantity = parseInt(meal.quantity, 10) || 0;
    if (quantity <= 0) continue;

    meals.push({
      product_id: String(productId),
      variant_id: String(meal.variantId || ''),
      sku: String(meal.sku || ''),
      quantity: quantity,
      title: String(meal.title || '').trim(),
    });
  }

  if (meals.length === 0) {
    return null;
  }

  return { schema_version: 1, meals: meals };
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports.buildPackPayload = buildPackPayload;
} else {
  window.buildPackPayload = buildPackPayload;
}
